/**
 * @copyright 2026 @ DigiNet
 * @author ANHTAI
 * @create 2026/07/13 09:15
 * @update 2026/07/13 09:15
 */

import { Column } from "devextreme-react/data-grid";
import { Attachment, Button, ButtonIcon, Checkbox, Col, DatePicker, Dropdown, Modal, ModalBody, ModalFooter, ModalHeader, NumberInput, Row, TextInput, Typography } from 'diginet-core-ui/components';
import { makeStyles } from "diginet-core-ui/theme";
import PropTypes from "prop-types";
import React, { forwardRef, memo, useEffect, useMemo, useRef, useState } from 'react';
import { connect } from "react-redux";
import { browserHistory } from "react-router";
import { bindActionCreators } from "redux";
import { uploadCDN_sync as uploadFileSync } from "../../../actions/file-upload-cdn-async";
import * as W07F2020Actions from "../../../actions/w07/w07F2020/w07F2020-actions";
import Config from "../../../config";
import GridActionBar from "../../common/action-bar/grid-action-bar-hover";
import ButtonExport from "../../common/button/button-export";
import MForm from "../../common/form/form";
import GridContainer from "../../common/grid-container/grid-container";
import { Loading } from "../../common/loading/loadingCore";
import ActionToolbar from "../../common/tool-bar/action-toolbar";

const useStyles = makeStyles((theme) => ({
    searchDiv: {
        [theme.breakpoints.down("md")]: {
            paddingTop: theme.spacing(4)
        }
    },
    infoGrid: {
        '& .dx-overlay-wrapper.dx-invalid-message.dx-invalid-message-always.dx-datagrid-invalid-message .dx-overlay-content.dx-resizable': {
            top: '108px !important'
        }
    },
}));

const initialDataMaster = {
    RDVoucherID: '',
    TransTypeID: '',
    RDVoucherNo: '',
    AStatusID: null,
    WareHouseID: '',
    WareHouseName: '',
    WareHouseID2: '',
    WareHouseName2: '',
    Description: '',
    RDVoucherDate: Config.convertDate(new Date(), null, "YYYY-MM-DD"),
    StatusColor: "",
    ApprovalNote: "",
    ReceiverID: "",
    ReceiverName: ""

};

const FormID = 'W07F2020';
const requiredField = ['TransTypeID', 'RDVoucherNo', 'RDVoucherDate', 'WareHouseID', 'WareHouseID2', 'ReceiverID', 'AStatusID'];
const arrRequiredColumn = ['InventoryID', 'InventoryName', 'UnitID', 'ActualQuantity'];

const W07F2020 = (props) => {
    const classes = useStyles();
    const { location } = props;
    const [isChanged, setIsChanged] = useState(false);
    const [formLoading, setFormLoading] = useState(false);
    const [cboTransTypeLoading, setCboTransTypeLoading] = useState(false);
    const [cboStatusLoading, setCboStatusLoading] = useState(false);
    const [openInfoModal, setOpenInfoModal] = useState(false);
    const [saveSuccess, setSaveSuccess] = useState(false);
    const [showUpdateStatusModal, setShowUpdateStatusModal] = useState(false);
    const [showCompleteModal, setShowCompleteModal] = useState(false);
    const [cboWarehouseKXLoading, setCboWarehouseKXLoading] = useState(false);
    const [cboWarehouseKNLoading, setCboWarehouseKNLoading] = useState(false);
    const [cboReceiverLoading, setCboReceiverLoading] = useState(false);
    const [mode, setMode] = useState(location?.state?.mode || 'view');
    const [error, _setError] = useState({});

    //=======Combo General ===========
    const [dataCboTransType, setDataCboTransType] = useState([]);
    const [dataCboStatus, setDataCboStatus] = useState([]);
    //=======Combo General ===========
    const [dataCboWarehouseKX, setDataCboWarehouseKX] = useState([]);
    const [dataCboWarehouseKN, setDataCboWarehouseKN] = useState([]);
    const [dataOldAttachments, setDataOldAttachments] = useState([]);
    const [dataCboReceiver, setDataCboReceiver] = useState([]);
    const [dataMaster, _setDataMaster] = useState({ ...initialDataMaster, RDVoucherID: location?.state?.RDVoucherID || '' });
    const [dataGrid, setDataGrid] = useState([]);
    const [requiredErrorFields, setRequiredErrorFields] = useState([]);

    const gridDetailRef = useRef(null);
    const dataMasterRef = useRef({ ...initialDataMaster });
    const dataErrorRef = useRef(error);
    const attachments = useRef([]);
    const deletedFile = useRef([]);

    const getInfo = (flag) => {
        if (location?.state) {
            const { mode = 'view', RDVoucherID = '' } = location?.state || {};
            return { mode, RDVoucherID }
        } else if (flag) {
            browserHistory.push(Config.env.url + "/W07F2010");
            return null;
        }
        return false;
    };

    const readOnly = mode === 'view' || formLoading;

    useEffect(() => {
        if (!getInfo()) return;
        loadCboTransType();
        loadCboStatus();
        loadCboWareHouse('KX');
        loadCboWareHouse('KN');
        if (mode !== 'add') {
            loadForm();
            loadAttachment();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const loadCboCmbReceiver = (wareHouseID = '') => {
        setCboReceiverLoading(true);
        props.W07F2020Actions.loadCmbReceiver(getParamGeneral('LoadcmbReceiver', { WareHouseID: wareHouseID }), (error, data) => {
            setCboReceiverLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                setDataCboReceiver(data || []);
            }
        });
    };

    const loadCboTransType = () => {
        setCboTransTypeLoading(true);
        props.W07F2020Actions.loadComboTransType(getParamGeneral(), (error, data) => {
            setCboTransTypeLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                if (mode === 'add') {
                    const { TransTypeID = '' } = data?.[0] || {};
                    setDataMaster({ TransTypeID }); // default
                    loadVoucher(TransTypeID);
                }
                setDataCboTransType(data || []);
            }
        });
    };

    const loadCboStatus = () => {
        setCboStatusLoading(true);
        props.W07F2020Actions.loadComboStatus(getParamGeneral(), (error, data) => {
            setCboStatusLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                setDataCboStatus(data || []);
            }
        });
    };

    const loadCboWareHouse = (Type) => {
        if(Type === 'KX') setCboWarehouseKXLoading(true);
        else if(Type === 'KN') setCboWarehouseKNLoading(true);
        props.W07F2020Actions.loadComboWareHouse({...getParamGeneral(), Type}, (error, data) => {
            if(Type === 'KX') setCboWarehouseKXLoading(false);
            else if(Type === 'KN') setCboWarehouseKNLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                if (mode === 'add') {
                    const { WareHouseID = '', WareHouseName = '' } = data?.[0] || {};
                    setDataMaster((Type === 'KN' ? {WareHouseID, WareHouseName} : {WareHouseID2: WareHouseID, WareHouseName2: WareHouseName})); // default
                    if (Type === 'KN') {
                        loadCboCmbReceiver(WareHouseID);
                    }
                }
                if(Type === 'KX') setDataCboWarehouseKX(data || []);
                else if(Type === 'KN') setDataCboWarehouseKN(data || []);
            }
        });
    };

    const loadComboUnit = (dataRow = {}, cb) => {
        props.W07F2020Actions.loadComboUnit(getParamGeneral('UnitID', dataRow), (error, data) => {
            if (cb) return cb(error, data);
        });
    };

    const handleDefaultModeAdd = () => {
        const { WareHouseID = '', WareHouseName = '' } = dataCboWarehouseKN?.[0] || {};
        const { WareHouseID: WareHouseID2, WareHouseName: WareHouseName2 = '' } = dataCboWarehouseKX?.[0] || {};
        let objPlus = {
            ...initialDataMaster,
            WareHouseID,
            WareHouseName,
            WareHouseID2,
            WareHouseName2,
            TransTypeID: dataCboTransType?.[0]?.TransTypeID || '',
        };
        loadVoucher();
        setDataMaster(objPlus);
        loadCboCmbReceiver(WareHouseID);
    };

    const getParamGeneral = (DataTypeID = '', dataRow = {}) => {
        const { WareHouseID = '', WareHouseID2 = '', RDVoucherID = '' } = dataMasterRef.current;
        const rDVoucherID = RDVoucherID || getInfo()?.RDVoucherID || '';
        let objResult = {
            AStatusID: null,
            TransTypeID: '',
            WareHouseID: '',
            RDVoucherID: '',
            StrSearch: '',
            ApprovalNote: '',
        };
        switch (DataTypeID) {
            case 'attachment':
            case 'complete':
            case 'checkEdit':
            case 'loadForm':
                objResult.RDVoucherID = rDVoucherID
                break;
            case 'UnitID':
                const { InventoryID = '' } = dataRow;
                objResult.StrSearch = InventoryID;
                break;
            case 'updateStatus':
                const { AStatusID = null, ApprovalNote = '' } = dataRow;
                objResult = { ...objResult, AStatusID, ApprovalNote, RDVoucherID: rDVoucherID };
                break;
            case 'loadInventoryGrid':
                const {  StrSearch = '' } = dataRow;
                objResult = { ...objResult, StrSearch, WareHouseID, WareHouseID2 };
                break;
            case 'LoadcmbReceiver':
                objResult.StrSearch = dataRow.WareHouseID || "";
                break;
            default:
                break;
        }
        if (!Config.isEmpty(dataRow)) {
            const arrParam = Object.keys(objResult);
            const arrDataRow = Object.keys(dataRow);
            for (let i = 0; i < arrDataRow.length; i++) {
                if (arrParam.includes(arrDataRow[i])) objResult[arrDataRow[i]] = dataRow[arrDataRow[i]];
            }
        }
        return objResult
    };

    const loadForm = (RDVoucherID, dataUpdateStatus = {}) => {
        const params = getParamGeneral('loadForm', dataUpdateStatus);
        if (RDVoucherID) params.RDVoucherID = RDVoucherID;
        setFormLoading(true);
        props.W07F2020Actions.loadForm(params, (error, data) => {
            setFormLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                const { master = {}, detail = [] } = data || {};
                setDataMaster(master, true);
                setDataGrid(detail);
                loadCboCmbReceiver(master?.WareHouseID);
            }
        });
    };

    const loadAttachment = () => {
        const params = getParamGeneral('attachment');
        props.W07F2020Actions.loadAttachment(params, (error, data) => {
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                setDataOldAttachments(data || []);
            }
        });
    };

    const loadVoucher = (TransTypeID = '') => {
        const params = getParamGeneral('LoadVoucherNo', { TransTypeID });
        setCboTransTypeLoading(true);
        props.W07F2020Actions.loadVoucher(params, (err, data) => {
            setCboTransTypeLoading(false);
            if (err) {
                Config.popupCore.show('ERROR', err);
                return false;
            } else if (data) {
                const { RDVoucherNo = '', RDVoucherID = '' } = data?.[0] || {};
                let objDataState = { RDVoucherNo };
                if (mode === 'add') objDataState.RDVoucherID = RDVoucherID;
                if (!Config.isEmpty(RDVoucherNo) && error?.RDVoucherNo) setError({ RDVoucherNo: '' });
                setDataMaster(objDataState);
            }
        });
    };

    const setDataMaster = (dataObj = {}, isReset = false) => {
        dataMasterRef.current = isReset ? { ...dataObj } : { ...dataMasterRef.current, ...dataObj };
        _setDataMaster(dataMasterRef.current);
    };

    const setError = (dataError = {}, isReset = false) => {
        dataErrorRef.current = isReset ? { ...dataError } : { ...dataErrorRef.current, ...dataError };
        _setError(dataErrorRef.current);
    };

    const _uploadFile = (files) => {
        const cdnToken = Config.decryptData(Config.getLocalStorage('CDN_TOKEN'));
        return uploadFileSync(files, 'multiple', cdnToken);
    };

    const _getAttachments = (file) => {
        const dataFile = file?.data?.paths || [];
        const listAttachments = Config.helpers.getFileInfomations(dataFile);
        let arrAttachment = [];
        listAttachments.forEach((att) => {
            arrAttachment.push({
                URL: att.url ? att.url : "",
                FileName: att.fileName ? att.fileName : "",
                FileSize: att.fileSize ? att.fileSize : "",
                FileExt: att.fileName ? att.fileName.split(".").pop() : "",
            });
        });
        if (dataOldAttachments && dataOldAttachments.length > 0) {
            arrAttachment = dataOldAttachments.concat(arrAttachment);
        }
        return arrAttachment;
    };

    const checkEdit = () => {
        const params = getParamGeneral('checkEdit');
        setFormLoading(true);
        props.W07F2020Actions.checkEdit(params, (error, data) => {
            setFormLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                if (data?.Status === 0) onReset('edit', true);
                else if (data?.Status === 1 && data?.Message) Config.popupCore.show('WARNING', data.Message);
            }
        });
    };

    const checkValidateMaster = (arrName) => {
        if (Config.isEmpty(arrName)) return;
        return arrName.map(item => {
            let val = dataMaster[item];
            return {
                name: item,
                rules: ["isRequired"],
                value: val
            }
        });
    };

    const handleDataSaveAtt = async (data) => {
        const dataResUploadFile = await _uploadFile(data, true);
        return _getAttachments(dataResUploadFile);
    };

    const onSave = async () => {
        let Mode = 0;
        let DataTypeID = 'SaveAddNew';
        let detail = [];
        const resultValidate = checkValidateMaster(requiredField);
        const validateFrom = MForm.formValidation(resultValidate);
        if (Object.keys(validateFrom).length > 0) {
            setError(validateFrom, true);
            return false;
        }
        await gridDetailRef.current.instance.saveEditData();
        detail = gridDetailRef.current.instance.option('dataSource') || [];
        setDataGrid([...detail]);
        let errorFields = [];
        detail.forEach(row => {
            arrRequiredColumn.forEach(field => {
                if (Config.isEmpty(row[field]) && !errorFields.includes(field)) {
                    errorFields.push(field);
                }
            });
        });
        if (errorFields.length > 0) {
            setRequiredErrorFields(errorFields);
            Config.popupCore.show(
                'WARNING',
                Config.lang('Vui_long_nhap_day_du_thong_tin_tren_luoi')
            );
            return false;
        }

        setRequiredErrorFields([]);
        const arrAttachment = await handleDataSaveAtt(attachments.current);
        if (mode === 'edit') {
            Mode = 1;
            DataTypeID = 'SaveEdit';
        }
        const params = {
            Mode,
            DataTypeID,
            ...dataMaster,
            detail,
            arrAttachment,
        };
        setFormLoading(true);
        props.W07F2020Actions.onSave(params, (error, data) => {
            setFormLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                if (data?.Status === 0) {
                    setRequiredErrorFields([]);
                    setSaveSuccess(true);
                    setMode('view');
                    loadForm();
                    Config.notify.show('success', data?.Message || Config.lang('Luu_thanh_cong'), 2000);
                } else if (data?.Message) Config.popupCore.show('WARNING', data.Message);
            }
        });
    };

    const handleOpenUpdateStatusModal = (status = false, isReload = false, dataUpdateStatus= {}) => {
        if (isReload) loadForm("", dataUpdateStatus); // Load lại form 
        setShowUpdateStatusModal(status);
    };

    const handleOpenCompleteModal = (status = false, isReload = false) => {
        if (isReload) {
            onReset('view');
            loadForm(); // Load lại form 
        }
        setShowCompleteModal(status);
    };

    const handleOpenInfoModal = async (status = false, dataChoose = []) => {
        if (!!status) { // Open
            if (gridDetailRef.current) {
                await gridDetailRef.current.instance.saveEditData();
                const newDataGrid = gridDetailRef.current.instance.option('dataSource') || [];
                setDataGrid(newDataGrid);
                setTimeout(() => setOpenInfoModal(status), 300);
            }
        } else {
            setOpenInfoModal(status);
            if (!Config.isEmpty(dataChoose)) {
                setIsChanged(true);
                setDataGrid(dataChoose);
            }
        }
    };

    const onChange = (keyName, e) => {
        if (!e || !keyName) return;
        let value = e?.value ?? e?.target?.value ?? '';
        if (Config.isEmpty(value) && ['DateFrom', 'DateTo'].includes(keyName)) value = null;
        const { WareHouseName = '', ReceiverName = "" } = e?.data || {};
        let objPlus = { [keyName]: value };
        switch (keyName) {
            case 'TransTypeID':
                if (Config.isEmpty(value)) {
                    objPlus.VoucherNo = '';
                } else loadVoucher(value);
                break;
            case 'WareHouseID':
                objPlus.WareHouseName = WareHouseName;
                loadCboCmbReceiver(value);
                break;
            case 'WareHouseID2':
                objPlus.WareHouseName2 = WareHouseName;
                break;
            case 'ReceiverID':
                objPlus.ReceiverName = ReceiverName;
                break;
            default:
                break;
        }
        setIsChanged(true);
        setDataMaster(objPlus);
        if (error?.[keyName] && !Config.isEmpty(value)) setError({ [keyName]: '' });
    };

    const renderNumberInputCol = (e, mode = 'view') => {
        if (!e) return false;
        const decimalValue = e?.value ?? null;
        let objProps = {
            viewType: 'none',
            decimalDigit: 8,
            thousandSeparator: ',',
            inputStyle: { textAlign: 'right' },
            delayOnChange: 0,
        }
        if (mode === 'edit') {
            objProps.onChange = (c) => {
                e.setValue(c?.value ?? null);
            };
            objProps.onBlur = () => {
                e.component.saveEditData();
            };
        }
        return <NumberInput
            nonStyle
            disabledNegative
            readOnly={mode !== 'edit'}
            value={decimalValue}
            {...objProps}
        />
    };

    const onChangeAttachments = e => {
        setIsChanged(true);
        attachments.current = e.allNewAttached ? e.allNewAttached : [];
        if (e.removedAttached && e.removedAttached.length > 0) {
            deletedFile.current = [...e.removedAttached];
            const _arrRemove = deletedFile.current.map(d => d.AttachmentID);
            setDataOldAttachments(
                dataOldAttachments.filter(att => {
                    return _arrRemove.indexOf(att.AttachmentID) < 0;
                })
            );
        }
    };

    const deleteRow = (e) => {
        if (!e) return;
        Config.popupCore.show('YES_NO', Config.lang('Ban_co_chac_muon_xoa?'), async () => {
            e.component.deleteRow(e.rowIndex);
            gridDetailRef.current.instance.refresh();
            setIsChanged(true);
        });
    };

    const renderAction = (e) => {
        return (
            <GridActionBar>
                <ButtonIcon
                    circular
                    disabled={formLoading || readOnly}
                    name={'Delete'}
                    size={'small'}
                    viewType={'text'}
                    onClick={() => deleteRow(e)} />
            </GridActionBar>
        );
    };

    const onReset = (modeProp, isNotResetData = false) => {
        if (!isNotResetData && modeProp === 'add') {
            handleDefaultModeAdd();
            setDataGrid([]);
            attachments.current = [];
            deletedFile.current = [];
            setDataOldAttachments([]);
        }
        setIsChanged(false);
        setSaveSuccess(false);
        setMode(modeProp);
        setRequiredErrorFields([]);
    };

    const renderDDColumn = (e) => {
        let dataSource = [];
        let props = {};
        const { dataField } = e?.column || {};
        let displayName = dataField;
        if (dataField.includes('ID')) displayName = dataField.replace('ID', 'Name');
        let displayExpr = displayName;
        switch (dataField) {
            case 'UnitID':
                props = {
                    action: { loadData: (params, cb) => loadComboUnit(e?.data, cb) }
                };
                break;
            default:
                break;
        }
        return <Dropdown
            valueExpr={dataField}
            displayExpr={displayExpr}
            viewType={'none'}
            value={e.value}
            valueObjectDefault={e.value ? {
                [dataField]: e?.value || '',
                [displayName]: e?.data?.[displayName] || '',
            } : null}
            onChange={(c) => {
                const value = c?.value ?? '';
                const name = c?.data?.[displayName] ?? '';
                e.component.cellValue(e.rowIndex, dataField, value);
                e.component.cellValue(e.rowIndex, displayName, name);
                e.setValue(value);
                e.component.saveEditData();
            }}
            {...(props?.action ? { action: props.action } : { dataSource })}
            {...props}
        />
    };

    const renderRequiredHeader = (caption) => {
        return () => (
            <div>
                {caption}
                <span style={{ color: 'red', marginLeft: 3 }}>
                    *
                </span>
            </div>
        );
    };

    const renderGrid = useMemo(() => {
        const dataSource = [...dataGrid];
        return (
            <GridContainer
                reference={ref => gridDetailRef.current = ref}
                pagerFullScreen={false}
                dataSource={dataSource}
                keyExpr={'InventoryID'}
                typePaging={'normal'}
                itemPerPage={20}
                onRowUpdated={(e) => {
                    setIsChanged(true);
                    setDataGrid(prev =>
                        prev.map(item =>
                            item.InventoryID === e.data.InventoryID
                                ? e.data
                                : item
                        )
                    );
                }}
                elementAttr={{ style: 'max-height: 520px; min-height: 320px' }}
                filterRow={{
                    visible: true,
                    showOperationChooser: false,
                }}
                editing={{
                    mode: 'cell',
                    refreshMode: 'reshape',
                    allowUpdating: !readOnly,
                    texts: { confirmDeleteMessage: '' },
                    startEditAction: 'click',
                }}
                onCellPrepared={(e) => {
                    const { cellElement, column, value, rowType } = e || {};

                    if (
                        cellElement &&
                        requiredErrorFields.includes(column?.dataField) &&
                        Config.isEmpty(value) &&
                        rowType !== 'filter'
                    ) {
                        cellElement.style.backgroundColor = '#ffd6d6';
                    }
                }}
            >
                <Column width={90} fixed allowSorting={false} cellRender={renderAction} caption={Config.lang('Hanh_dong')} alignment={'center'} visible={Config.isMobile} />
                <Column width={340}  caption={Config.lang('Ma_hang')} 
                    headerCellRender={renderRequiredHeader(Config.lang('Ma_hang'))} dataField={'InventoryID'} />
                <Column minWidth={460} caption={Config.lang('Ten_hang')} headerCellRender={renderRequiredHeader(Config.lang('Ten_hang'))} dataField={'InventoryName'} />
                <Column width={200} caption={Config.lang('DVT')} headerCellRender={renderRequiredHeader(Config.lang('DVT'))} dataField={'UnitID'} editCellRender={renderDDColumn} />
                <Column width={150} caption={Config.lang('So_luong')} headerCellRender={renderRequiredHeader(Config.lang('So_luong'))} dataField={'ActualQuantity'} dataType={'number'} allowFiltering={false} cellRender={renderNumberInputCol} editCellRender={(e) => renderNumberInputCol(e, 'edit')} />
                <Column allowEditing={false} width={50} fixed alignment={"right"} fixedPosition={"right"} visible={!Config.isMobile} cellRender={renderAction} />
            </GridContainer>
        )
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataGrid, formLoading, readOnly, mode, classes, renderRequiredHeader]);

    const onBack = () => {
        browserHistory.goBack();
    };

    if (!getInfo(true)) return null;
    return (
        <div className={'page-container'}>
            <Loading visible={formLoading} />
            {openInfoModal && <InfoModal
                open={openInfoModal}
                handleOpen={(status, dataChoose) => handleOpenInfoModal(status, dataChoose)}
                dataForm={dataMasterRef.current}
                getParamGeneral={getParamGeneral}
                renderNumberInputCol={renderNumberInputCol}
                dataGridParent={dataGrid}
                {...props}
            />}
            {showUpdateStatusModal && <UpdateStatusModal
                open={showUpdateStatusModal}
                dataCboStatus={dataCboStatus}
                handleOpen={(status, isReload, dataUpdateStatus) => handleOpenUpdateStatusModal(status, isReload, dataUpdateStatus)}
                paramSave={(data) => getParamGeneral('updateStatus', data)}
                {...props}
            />}
            {showCompleteModal && <CompleteModal
                open={showCompleteModal}
                handleDataSaveAtt={handleDataSaveAtt}
                handleOpen={(status, isReload) => handleOpenCompleteModal(status, isReload)}
                paramSave={() => getParamGeneral('complete')}
                {...props}
            />}
            <ActionToolbar title={Config.lang("Dieu_chuyen_noi_bo")} onBack={onBack}>
                <div className={'wrap align-center align-between full_w'}>
                    <div className={'wrap align-center'}>
                        <Button
                            color={'info'}
                            startIcon={"Save"}
                            viewType={"text"}
                            label={Config.lang('Luu')}
                            disabled={readOnly || saveSuccess || !isChanged}
                            onClick={() => onSave()}
                        />
                        <Button
                            color={'warning'}
                            startIcon={"Edit"}
                            viewType={"text"}
                            className={"mgl1x"}
                            label={Config.lang('Sua')}
                            disabled={(mode === "edit" && !saveSuccess) || mode === 'add' || dataMaster?.IsStatus === 1 || dataMaster?.IsStatus === 90 || dataMaster?.IsComfirm === 90}
                            onClick={() => checkEdit()}
                        />
                        <Button
                            color={'primary'}
                            startIcon={"Add"}
                            viewType={"text"}
                            className={"mgl1x"}
                            label={Config.lang('Nhap_tiep')}
                            disabled={mode === "add" || mode === "edit"}
                            onClick={() => onReset('add')}
                        />
                        <ButtonExport
                            isViewPDF
                            isPreview
                            isCoreUI
                            onlyShowPopup
                            showBtnPrint
                            className={'mgl1x'}
                            disabled={mode === 'add' || dataMaster?.IsPrint === 0}
                            name={Config.lang('In1')}
                            transTypeID={'Export_Quotation'}
                            reportTypeID={FormID}
                            param={[
                                { type: "Varchar", id: "UserID", value: Config.profile?.UserID || '' },
                                { type: "Varchar", id: "Language", value: Config.language || '84' },
                                { type: "VarChar", id: "DivisionID", value: Config.profile.DivisionID },
                                { type: "VarChar", id: "DataTypeID", value: "PRINT" },
                                { type: "VarChar", id: "RDVoucherID", value: dataMaster?.RDVoucherID || '' },
                            ]}
                        />
                        <Button
                            color={'primary'}
                            className={'mgl1x'}
                            viewType={"text"}
                            startIcon={"SyncHorizontal"}
                            label={Config.lang('Cap_nhat_trang_thai')}
                            disabled={mode !== 'view' || dataMaster?.IsComfirm === 90 || dataMaster?.IsStatus === 1}
                            onClick={() => handleOpenUpdateStatusModal(true)}
                        />
                    </div>
                    <div>
                        <Button
                            color={'success'}
                            startIcon={"Approval"}
                            viewType={"text"}
                            label={Config.lang('Hoan_tat')}
                            disabled={mode === 'add' || dataMaster?.IsComfirm === 1 || dataMaster?.IsComfirm === 90}
                            onClick={() => setShowCompleteModal(true)}
                        />
                    </div>
                </div>
            </ActionToolbar>
            <Row className={'mgt0'}>
                <Col xs={12} sm={6} md={6} lg={3}>
                    <Dropdown
                        required
                        viewType={'outlined'}
                        valueExpr={'TransTypeID'}
                        displayExpr={'TransTypeName'}
                        label={Config.lang('Loai_nghiep_vu')}
                        readOnly={readOnly || mode === 'edit'}
                        loading={cboTransTypeLoading}
                        dataSource={dataCboTransType}
                        error={error?.TransTypeID}
                        value={dataMaster?.TransTypeID}
                        onChange={e => onChange('TransTypeID', e)}
                    />
                </Col>
                <Col xs={12} sm={6} md={6} lg={3}>
                    <TextInput
                        readOnly
                        required
                        viewType={'outlined'}
                        value={dataMaster?.RDVoucherNo}
                        error={error?.RDVoucherNo}
                        label={Config.lang('So_phieu')}
                    />
                </Col>
                <Col xs={12} sm={6} md={6} lg={3}>
                    <DatePicker
                        required
                        readOnly={readOnly || mode === 'edit'}
                        viewType={'outlined'}
                        displayFormat={"DD/MM/YYYY"}
                        label={Config.lang('Ngay_phieu')}
                        error={error?.RDVoucherDate}
                        value={dataMaster?.RDVoucherDate}
                        onChange={e => onChange('RDVoucherDate', e)}
                    />
                </Col>
                <Col xs={12} sm={6} md={6} lg={3}>
                    <Dropdown
                        required
                        viewType={'outlined'}
                        readOnly={mode !== 'add'}
                        valueExpr={'AStatusID'}
                        displayExpr={'StatusName'}
                        label={Config.lang('Trang_thai')}
                        loading={cboStatusLoading}
                        dataSource={dataCboStatus}
                        error={error?.AStatusID}
                        value={dataMaster?.AStatusID}
                        onChange={e => onChange('AStatusID', e)}
                        valueObjectDefault={!Config.isEmpty(dataMaster?.AStatusID) ? {
                            AStatusID: dataMaster?.AStatusID || null,
                            StatusName: dataMaster?.StatusName || ""
                        } : null}
                        renderSelectedItem={(e) => {
                            const { StatusName = '' } = e?.data || {};
                            return <Typography color={dataMaster?.StatusColor}>{StatusName}</Typography>
                        }}
                    />
                </Col>
                <Col xs={12} sm={6} md={3} lg={3}>
                    <Dropdown
                        required
                        readOnly={readOnly}
                        viewType={'outlined'}
                        valueExpr={'WareHouseID'}
                        displayExpr={'WareHouseName'}
                        label={Config.lang('Kho_xuat')}
                        loading={cboWarehouseKXLoading}
                        dataSource={dataCboWarehouseKX}
                        error={error?.WareHouseID2}
                        value={dataMaster?.WareHouseID2}
                        valueObjectDefault={dataMaster?.WareHouseID2 ? {
                            WareHouseID: dataMaster?.WareHouseID2 || '',
                            WareHouseName: dataMaster?.WareHouseName2 || '',
                        } : null}
                        onChange={e => onChange('WareHouseID2', e)}
                    />
                </Col>
                <Col xs={12} sm={6} md={3} lg={3}>
                    <Dropdown
                        required
                        readOnly={readOnly}
                        viewType={'outlined'}
                        valueExpr={'WareHouseID'}
                        displayExpr={'WareHouseName'}
                        label={Config.lang('Kho_nhap')}
                        loading={cboWarehouseKNLoading}
                        dataSource={dataCboWarehouseKN}
                        error={error?.WareHouseID}
                        value={dataMaster?.WareHouseID}
                        valueObjectDefault={dataMaster?.WareHouseID ? {
                            WareHouseID: dataMaster?.WareHouseID || '',
                            WareHouseName: dataMaster?.WareHouseName || '',
                        } : null}
                        onChange={e => onChange('WareHouseID', e)}
                    />
                </Col>
                <Col xs={12} sm={12} md={6} lg={6}>
                    <Dropdown
                        required
                        readOnly={readOnly}
                        viewType={'outlined'}
                        valueExpr={'ReceiverID'}
                        displayExpr={'ReceiverName'}
                        label={Config.lang('Nguoi_nhan')}
                        loading={cboReceiverLoading}
                        dataSource={dataCboReceiver}
                        error={error?.ReceiverID}
                        value={dataMaster?.ReceiverID}
                        valueObjectDefault={!Config.isEmpty(dataMaster?.ReceiverID) ? {
                            ReceiverID: dataMaster?.ReceiverID || '',
                            ReceiverName: dataMaster?.ReceiverName || '',
                        } : null}
                        onChange={e => onChange('ReceiverID', e)}
                    />
                </Col>
                <Col xs={12} sm={12} md={6} lg={6}>
                    <TextInput
                        multiline
                        rows={6}
                        maxRows={6}
                        viewType={'outlined'}
                        readOnly={readOnly}
                        value={dataMaster?.Description}
                        label={Config.lang('Dien_giai')}
                        onChange={e => onChange('Description', e)}
                    />
                </Col>
                <Col xs={12} sm={12} md={6} lg={6}>
                    <Attachment
                        multiple
                        isStripDomain
                        height={160}
                        style={{ minHeight: 120 }}
                        readOnly={readOnly}
                        domain={Config.getCDNPath()}
                        data={dataOldAttachments}
                        onChange={onChangeAttachments}
                    />
                </Col>
                <Col xs={12}>
                    <Button
                        viewType={'outlined'}
                        color={'primary'}
                        className={'mgb2x'}
                        startIcon={'AddFilled'}
                        disabled={readOnly || formLoading}
                        label={Config.lang('Chon_hang_hoa')}
                        onClick={() => handleOpenInfoModal(true)}
                    />
                    {renderGrid}
                </Col>
            </Row>
        </div>
    );
}

const InfoModal = memo(forwardRef((props, _) => {
    const classes = useStyles();
    const isMobile = window.innerWidth < 576;
    const { open, handleOpen, renderNumberInputCol, getParamGeneral, dataGridParent } = props;
    const [isEdit, setIsEdit] = useState(false);
    const [gridLoading, setGridLoading] = useState(false);
    const [checkChosenCol, setCheckChosenCol] = useState(false);
    const [chosenNum, setChosenNum] = useState(0);
    const [strSearch, setStrSearch] = useState('');
    const [dataGrid, setDataGrid] = useState([]);

    const gridRef = useRef(null);
    const chosenNumRef = useRef(null);
    const chooseOrderRef = useRef(0);

    useEffect(() => {
        loadInventoryGrid();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const loadInventoryGrid = () => {
        const params = (getParamGeneral && getParamGeneral('loadInventoryGrid', {StrSearch: strSearch})) || {};
        if (Config.isEmpty(params)) return;
        setGridLoading(true);
        props.W07F2020Actions.loadDataInventory(params, (error, data) => {
            setGridLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                const dataCustomGrid = data.map(item => ({ ...item, IsChose: +dataGridParent.some(item2 => item.InventoryID === item2?.InventoryID) }));
                setDataGrid(dataCustomGrid);
            }
        });
    };

    const handleChoose = async () => {
        let detail = [];
        await gridRef.current.instance.saveEditData();
        detail = gridRef.current.instance.option('dataSource') || [];
        if (!Config.isEmpty(detail)) detail = detail.filter(item => !!item?.IsChose).sort((a, b) => { // Dòng có check
            // Dòng không có ChooseOrder là dữ liệu cũ -> đưa lên đầu
            if (!a.ChooseOrder && !b.ChooseOrder) return 0;
            if (!a.ChooseOrder) return -1;
            if (!b.ChooseOrder) return 1;
            // Dòng có ChooseOrder thì theo thứ tự click
            return a.ChooseOrder - b.ChooseOrder;
        });
        const paramPlus = (getParamGeneral && getParamGeneral('ListINVDetail')) || {};
        const params = {
            StrSearch: '',
            ...paramPlus,
            data: JSON.stringify(detail)
        };
        setGridLoading(true);
        props.W07F2020Actions.chooseInventory(params, (error, data) => {
            setGridLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                const orderMap = new Map(
                    detail.map((item, index) => [item.InventoryID, index])
                );
                const chosenData = data
                    .filter(item => !dataGridParent.some(x => x.InventoryID === item.InventoryID))
                    .sort((a, b) =>
                        (orderMap.get(a.InventoryID) ?? 999999) -
                        (orderMap.get(b.InventoryID) ?? 999999)
                    );
                const oldData = dataGridParent || [];
                const result = [
                    ...oldData,
                    ...chosenData
                ];
                handleOpen && handleOpen(false, result); // Đóng Pop + Reload Form Cha
            }
        });
    };

    const onChangeFilter = (e) => {
        const value = e?.value ?? e?.target?.value ?? '';
        setStrSearch(value);
    };

    const renderChoseColumn = (e) => {
        return <Checkbox
            style={{ margin: 'auto' }}
            checked={e?.value === 1}
            onChange={(data) => {
                setIsEdit(true);
                const val = !!data?.value;
                const rowData = dataGrid.find(item => item.InventoryID === e.component.cellValue(e.rowIndex, 'InventoryID'));
                if (!rowData) return;
                rowData.IsChose = +val;
                if (val) {
                    chooseOrderRef.current += 1;
                    rowData.ChooseOrder = chooseOrderRef.current;
                } else {
                    rowData.ChooseOrder = null;
                }
                e.component.cellValue(e.rowIndex, 'IsChose', +val);
                e.component.cellValue(e.rowIndex, 'ChooseOrder', rowData.ChooseOrder);
                e.component.saveEditData();
                const oldVal = Number(chosenNumRef.current?.innerText) ?? 0;
                setChosenNum(val ? oldVal + 1 : oldVal - 1);
                let dataSource = e.component.option('dataSource') || [];
                if (!Config.isEmpty(dataSource)) dataSource = dataSource.filter(item => !!item?.IsChose);
                if (Config.isEmpty(dataSource)) setIsEdit(false);
            }}
        />;
    };

    const renderGridInfo = useMemo(() => {
        const dataSource = dataGrid.flatMap((item) => checkChosenCol && !item?.IsChose ? [] : [item]);
        return (
            <>
                <Loading size={'small'} visible={gridLoading} />
                <GridContainer
                    reference={ref => (gridRef.current = ref)}
                    pagerFullScreen={false}
                    dataSource={dataSource}
                    keyExpr={'InventoryID'}
                    typePaging={'normal'}
                    itemPerPage={50}
                    elementAttr={{ style: 'max-height: 460px; min-height: 320px;', class: classes.infoGrid }}
                    filterRow={{
                        visible: true,
                        showOperationChooser: false,
                    }}
                    onRowUpdated={() => {
                        setIsEdit(true);
                    }}
                    onEditingStart={(e) => {
                        if (!e?.data?.IsChose) e.cancel = true; // Không check không cho Edit
                    }}>
                    <Column allowFiltering={false} allowSorting={false} width={80} alignment={'center'} dataField={'IsChose'} caption={Config.lang('Chon')} cellRender={renderChoseColumn} />
                    <Column dataField="ChooseOrder" visible={false} />
                    <Column width={300} caption={Config.lang('Ma_hang')} dataField={'InventoryID'} />
                    <Column minWidth={350} caption={Config.lang('Ten_hang')} dataField={'InventoryName'} />
                    <Column width={200} caption={Config.lang('DVT')} dataField={'UnitID'} />
                    <Column width={230} dataType={'number'} caption={Config.lang('So_luong_ton')} dataField={'WareHouseQTY'} cellRender={renderNumberInputCol} />
                </GridContainer>
            </>
        )
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataGrid, gridLoading, checkChosenCol]);

    const onChange = async (fieldName, e) => {
        if (Config.isEmpty(fieldName)) return;
        let value = e?.value ?? e?.target?.value ?? '';
        switch (fieldName) {
            case 'chosen':  // Điểm  dự kiện
                if (!!value) {
                    await gridRef.current.instance.saveEditData();
                    const dataSource = gridRef.current.instance.option('dataSource') || [];
                    setDataGrid(dataSource);
                }
                setTimeout(() => setCheckChosenCol(value));
                break;
            default:
                break;
        }
        setIsEdit(true);
    };

    // Modal Order 
    return (
        <Modal open={open} size={'xl'} onClose={() => handleOpen(false)}>
            <ModalHeader title={Config.lang('Thong_tin_hang_hoa')} />
            <ModalBody>
                <Row>
                    <Col xs={12}>
                        <div className={'wrap align-right align-between'}>
                            <div className={'display_row align-center'}>
                                <Checkbox
                                    className={'mgr1x'}
                                    checked={!!checkChosenCol}
                                    disabled={Config.isEmpty(dataGrid)}
                                    label={Config.lang('Hien_thi_du_lieu_da_chon')}
                                    onChange={e => onChange('chosen', e)}
                                />
                                (<Typography ref={chosenNumRef}>{chosenNum}</Typography>)
                            </div>
                            <div className={`wrap align-center ${classes.searchDiv}`}>
                                <TextInput
                                    style={{ minWidth: isMobile ? '100%' : 400 }}
                                    className={isMobile ? 'pdv2x' : ''}
                                    viewType={'outlined'}
                                    value={strSearch}
                                    endIcon={'Search'}
                                    onChange={(e) => onChangeFilter(e)}
                                    placeholder={Config.lang('Noi_dung_can_tim')} />
                                <Button
                                    viewType={'outlined'}
                                    color={'primary'}
                                    startIcon={'Search'}
                                    label={Config.lang('Tim_kiem')}
                                    className={isMobile ? '' : 'mgl4x'}
                                    onClick={loadInventoryGrid}
                                />
                            </div>
                        </div>
                    </Col>
                    <Col xs={12}>{renderGridInfo}</Col>
                </Row>
            </ModalBody>
            <ModalFooter>
                <Button
                    viewType={'filled'}
                    color={'info'}
                    disabled={!isEdit || !chosenNum}
                    label={Config.lang('Chon')}
                    onClick={handleChoose}
                />
            </ModalFooter>
        </Modal>
    );
}));

const UpdateStatusModal = memo(forwardRef((props, _) => {
    const { open, handleOpen, dataCboStatus, paramSave } = props;
    const [isEdit, setIsEdit] = useState(false);
    const [formLoading, setFormLoading] = useState(false);
    const [error, setError] = useState({});
    const [dataMaster, setDataMaster] = useState({
        AStatusID: null,
        ApprovalNote: ''
    });

    const onChange = async (fieldName, e) => {
        if (Config.isEmpty(fieldName)) return;
        const value = e?.value ?? e?.target?.value ?? '';
        if(fieldName === "AStatusID") Number(value);
        const obPlus = { ...dataMaster, [fieldName]: value };
        setDataMaster(obPlus);
        if (!Config.isEmpty(value) && error?.[fieldName]) setError({ ...error, [fieldName]: '' });
        setIsEdit(true);
    };

    const checkValidateMaster = (arrName) => {
        if (Config.isEmpty(arrName)) return;
        return arrName.map(item => {
            let val = dataMaster[item];
            return {
                name: item,
                rules: ["isRequired"],
                value: val
            }
        });
    };

    const onSave = async () => {
        const resultValidate = checkValidateMaster(['AStatusID']);
        const validateFrom = MForm.formValidation(resultValidate);
        if (Object.keys(validateFrom).length > 0) {
            setError(validateFrom, true);
            return false;
        }
        setFormLoading(true);
        props.W07F2020Actions.updateStatus(paramSave(dataMaster), (error, data) => {
            setFormLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                if (data?.Status === 0) {
                    handleOpen(false, true, dataMaster);
                    Config.notify.show('success', Config.lang('Luu_thanh_cong'), 2000);
                } else if (data?.Message) Config.popupCore.show('WARNING', data.Message);
            }
        });
    };

    // Modal Order 
    return (
        <Modal open={open} size={'sm'} onClose={() => handleOpen(false)}>
            <ModalHeader title={Config.lang('Cap_nhat_trang_thai')} />
            <ModalBody>
                <Loading visible={formLoading} />
                <Row>
                    <Col xs={12}>
                        <Dropdown
                            required
                            viewType={'outlined'}
                            valueExpr={'AStatusID'}
                            displayExpr={'StatusName'}
                            dataSource={dataCboStatus}
                            error={error?.AStatusID}
                            value={dataMaster?.AStatusID}
                            label={Config.lang('Trang_thai')}
                            onChange={e => onChange('AStatusID', e)}
                        />
                    </Col>
                    <Col xs={12}>
                        <TextInput
                            multiline
                            rows={5}
                            maxRows={5}
                            viewType={'outlined'}
                            label={Config.lang('Ghi_chu')}
                            value={dataMaster?.ApprovalNote}
                            onChange={e => onChange('ApprovalNote', e)}
                        />
                    </Col>
                </Row>
            </ModalBody>
            <ModalFooter>
                <div className={'jus-end'}>
                    <Button
                        viewType={'filled'}
                        color={'info'}
                        startIcon={'Save'}
                        disabled={!isEdit}
                        label={Config.lang('Luu')}
                        onClick={onSave}
                    />
                </div>
            </ModalFooter>
        </Modal>
    );
}));

const CompleteModal = memo(forwardRef((props, _) => {
    const { open, handleOpen, paramSave, handleDataSaveAtt } = props;
    const [isEdit, setIsEdit] = useState(false);
    const [formLoading, setFormLoading] = useState(false);
    const [error, setError] = useState({});
    const [dataOldAttachments, setDataOldAttachments] = useState([]);
    const [dataMaster, setDataMaster] = useState({
        ApprovalNotesU: ''
    });

    const attachments = useRef([]);
    const deletedFile = useRef([]);

    const onChange = async (fieldName, e) => {
        if (Config.isEmpty(fieldName)) return;
        const value = e?.value ?? e?.target?.value ?? '';
        const obPlus = { ...dataMaster, [fieldName]: value };
        setDataMaster(obPlus);
        if (!Config.isEmpty(value) && error?.[fieldName]) setError({ ...error, [fieldName]: '' });
        setIsEdit(true);
    };

    const onSave = async () => {
        const currentAttachments = [
            ...(attachments.current || []),
            ...(dataOldAttachments || [])
        ];

        // validate attachment
        if (currentAttachments.length === 0) {
            setError({
                Attachment: Config.lang('Vui_long_dinh_kem_tap_tin')
            }, true);
            return false;
        }
        const arrAttachment = handleDataSaveAtt && await handleDataSaveAtt(attachments.current);
        setFormLoading(true);
        props.W07F2020Actions.completeTask({ ...paramSave(), arrAttachment }, (error, data) => {
            setFormLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                if (data?.Status === 0) {
                    handleOpen(false, true);
                    Config.notify.show('success', data?.Message || Config.lang('Luu_thanh_cong'), 2000);
                } else if (data?.Message) Config.popupCore.show('WARNING', data.Message);
            }
        });
    };

    const onChangeAttachments = e => {
        setIsEdit(true);
        attachments.current = e.allNewAttached ? e.allNewAttached : [];
        if (attachments.current?.length > 0 && error?.Attachment) setError({ Attachment: '' });
        if (e.removedAttached && e.removedAttached.length > 0) {
            deletedFile.current = [...e.removedAttached];
            const _arrRemove = deletedFile.current.map(d => d.AttachmentID);
            setDataOldAttachments(
                dataOldAttachments.filter(att => {
                    return _arrRemove.indexOf(att.AttachmentID) < 0;
                })
            );
        }
    };

    return (
        <Modal open={open} size={'sm'} onClose={() => handleOpen(false)}>
            <ModalHeader title={Config.lang('Hoan_tat_phieu_van_chuyen_noi_bo')} />
            <ModalBody>
                <Loading visible={formLoading} />
                <Row>
                    <Col xs={12}>
                        <TextInput
                            viewType={'outlined'}
                            label={Config.lang('Ghi_chu')}
                            value={dataMaster?.ApprovalNotesU}
                            onChange={e => onChange('ApprovalNotesU', e)}
                        />
                    </Col>
                    <Col xs={12}>
                        <Attachment
                            multiple
                            required
                            isStripDomain
                            height={180}
                            error={error?.Attachment}
                            style={{ minHeight: 120 }}
                            domain={Config.getCDNPath()}
                            data={dataOldAttachments}
                            onChange={onChangeAttachments}
                        />
                    </Col>
                </Row>
            </ModalBody>
            <ModalFooter>
                <div className={'jus-end'}>
                    <Button
                        viewType={'filled'}
                        color={'success'}
                        startIcon={'Approval'}
                        disabled={!isEdit}
                        label={Config.lang('Hoan_tat')}
                        onClick={onSave}
                    />
                </div>
            </ModalFooter>
        </Modal>
    );
}));

UpdateStatusModal.propTypes = {
    open: PropTypes.bool,
    handleOpen: PropTypes.func,
    paramSave: PropTypes.object,
};

UpdateStatusModal.defaultProps = {
    open: false,
    paramSave: {},
};

CompleteModal.propTypes = {
    open: PropTypes.bool,
    handleOpen: PropTypes.func,
    handleDataSaveAtt: PropTypes.func,
    paramSave: PropTypes.object,
};

CompleteModal.defaultProps = {
    open: false,
    paramSave: {},
};

export default connect(null, (dispatch) => ({
    W07F2020Actions: bindActionCreators(W07F2020Actions, dispatch),
}))(W07F2020);


